import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2aac12ea"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "popup-container"
}

import PopupEditGroup from "@/components/popup/PopupEditGroup.vue";
import PopupEditGroupMembers from "@/components/popup/PopupEditGroupMembers.vue";
import PopupNotificationsSetting from "@/components/popup/PopupNotificationsSetting.vue";
import PopupInfoDeleteChat from "@/components/popup/PopupInfoDeleteChat.vue";
import PopupInfoDeleteMessages from "@/components/popup/PopupInfoDeleteMessages.vue";
import PopupInfoLeaveGroup from "@/components/popup/PopupInfoLeaveGroup.vue";
import PopupInfoDeleteUserAccount from "@/components/popup/PopupInfoDeleteUserAccount.vue";
import PopupInfoBlockUser from "@/components/popup/PopupInfoBlockUser.vue";
import PopupInfoUnblockUser from "@/components/popup/PopupInfoUnblockUser.vue";
import PopupInfoReportUser from "@/components/popup/PopupInfoReportUser.vue";
import PopupInfoMuteChat from "@/components/popup/PopupInfoMuteChat.vue";
import PopupWhatIsNew from "@/components/popup/PopupWhatIsNew/PopupWhatIsNew.vue";
import { GetterTypes } from "@/store";
import { useComputedValue } from "@/composables";
import { PopupTypes } from "@/store/app/state";
import PopupForwardMessage from "./PopupForwardMessage.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'PopupContainer',
  setup(__props) {

const popupType = useComputedValue<PopupTypes>(GetterTypes.GET_POPUP_TYPE);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(popupType) !== _unref(PopupTypes).WHAT_IS_NEW)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_unref(popupType) === _unref(PopupTypes).EDIT_GROUP)
            ? (_openBlock(), _createBlock(PopupEditGroup, { key: 0 }))
            : _createCommentVNode("", true),
          (_unref(popupType) === _unref(PopupTypes).EDIT_GROUP_MEMBERS)
            ? (_openBlock(), _createBlock(PopupEditGroupMembers, { key: 1 }))
            : _createCommentVNode("", true),
          (_unref(popupType) === _unref(PopupTypes).FORWARD_MESSAGE)
            ? (_openBlock(), _createBlock(PopupForwardMessage, { key: 2 }))
            : _createCommentVNode("", true),
          (_unref(popupType) === _unref(PopupTypes).INFO_DELETE_CHAT)
            ? (_openBlock(), _createBlock(PopupInfoDeleteChat, { key: 3 }))
            : _createCommentVNode("", true),
          (_unref(popupType) === _unref(PopupTypes).INFO_DELETE_MESSAGES)
            ? (_openBlock(), _createBlock(PopupInfoDeleteMessages, { key: 4 }))
            : _createCommentVNode("", true),
          (_unref(popupType) === _unref(PopupTypes).INFO_LEAVE_GROUP)
            ? (_openBlock(), _createBlock(PopupInfoLeaveGroup, { key: 5 }))
            : _createCommentVNode("", true),
          (_unref(popupType) === _unref(PopupTypes).INFO_MUTE_CHAT)
            ? (_openBlock(), _createBlock(PopupInfoMuteChat, { key: 6 }))
            : _createCommentVNode("", true),
          (_unref(popupType) === _unref(PopupTypes).NOTIFICATIONS_SETTING)
            ? (_openBlock(), _createBlock(PopupNotificationsSetting, { key: 7 }))
            : _createCommentVNode("", true),
          (_unref(popupType) === _unref(PopupTypes).INFO_DELETE_USER_ACCOUNT)
            ? (_openBlock(), _createBlock(PopupInfoDeleteUserAccount, { key: 8 }))
            : _createCommentVNode("", true),
          (_unref(popupType) === _unref(PopupTypes).INFO_REPORT_USER)
            ? (_openBlock(), _createBlock(PopupInfoReportUser, { key: 9 }))
            : _createCommentVNode("", true),
          (_unref(popupType) === _unref(PopupTypes).INFO_BLOCK_USER)
            ? (_openBlock(), _createBlock(PopupInfoBlockUser, { key: 10 }))
            : _createCommentVNode("", true),
          (_unref(popupType) === _unref(PopupTypes).INFO_UNBLOCK_USER)
            ? (_openBlock(), _createBlock(PopupInfoUnblockUser, { key: 11 }))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_unref(popupType) === _unref(PopupTypes).WHAT_IS_NEW)
      ? (_openBlock(), _createBlock(PopupWhatIsNew, { key: 1 }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})